import { render, staticRenderFns } from "./notice-panel.vue?vue&type=template&id=356e24cc&"
import script from "./notice-panel.vue?vue&type=script&lang=js&"
export * from "./notice-panel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports